import { render, staticRenderFns } from "./roomGiftList.vue?vue&type=template&id=9b88bad0&scoped=true"
import script from "./roomGiftList.vue?vue&type=script&lang=js"
export * from "./roomGiftList.vue?vue&type=script&lang=js"
import style0 from "./roomGiftList.vue?vue&type=style&index=0&id=9b88bad0&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b88bad0",
  null
  
)

export default component.exports